import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { router } from '@inertiajs/react';
import { Row, Col } from 'react-grid-system';
import Layout from '../../templates/Layout';
import H1 from '../../atoms/title/H1';
import { Helmet } from 'react-helmet';
import UsersTable from '../../organisms/table/UsersTable';
import Filters from '../../organisms/users/Filters';
import PaginationList from '../../molecules/PaginationList';
import { FEAT_USERS_TABLE_FILTERS, FEAT_USERS_TABLE_PAGINATION, } from '../../../config/feature';
import Notice from '../../molecules/Notice';
const GetUsers = ({ users, filters: initialFilters, notice, }) => {
    const { t } = useTranslation();
    const [, setPage] = useState(users.current_page);
    const [filters, setFilters] = useState(initialFilters);
    const [loading, setLoading] = useState(false);
    router.on('start', () => setLoading(true));
    router.on('finish', event => {
        if (!event.detail.visit.interrupted) {
            setLoading(false);
        }
    });
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('users.title') }) }), _jsx(H1, { "data-testid": "title", children: t('users.title') }), notice && _jsx(Notice, { ...notice }), _jsx(Row, { children: _jsxs(Col, { sm: 12, children: [FEAT_USERS_TABLE_FILTERS.isEnabled && (_jsx(Filters, { filters: filters, setFilters: setFilters })), _jsx(UsersTable, { loading: loading, users: users.data }), FEAT_USERS_TABLE_PAGINATION.isEnabled && (_jsx(PaginationList, { disabled: loading, links: users.links, setPage: setPage }))] }) })] }));
};
export default GetUsers;
